export default __webpack_public_path__ + "static/media/office8small.0f3b3589.jpg";